import { createSlice } from "@reduxjs/toolkit";

const initialProviderNoteState = {
  error: null,
  listLoading: false,
  data: null,
  actionsLoading: false,
  practices: [],
  selectedNote: null,
  noteSections: null,
  providerNoteSettingsData: null,
  selectedPatient: null,
  vitalsSettings: null,
  referralsSettings: null,
  ccmSettings: null,
  selectedNoteSettings: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const providerNoteSlice = createSlice({
  name: "providerNote",
  initialState: initialProviderNoteState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    fetchData: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.actionsLoading = false;
      state.data = data;
    },
    noteFetched: (state, action) => {
      const { note } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.selectedNote = note;
    },
    initConfirmationDialog: (state, action) => {
      const { data } = action.payload;
      state.confirmationDialogObj = data;
    },
    initNotificationDialog: (state, action) => {
      const { data } = action.payload;
      state.notificationDialogObj = data;
    },
    pdfViewerDataFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.selectedPdfData = data;
    },
    noteSectionsFetched: (state, action) => {
      const { sections } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.noteSections = sections;
    },
    providerNoteSettingsFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.providerNoteSettingsData = data;
    },
    providersFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.allProviders = data.map((provider) => provider.User);
    },
    labsMetaFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.labsMeta = data;
    },
    refusalMetaFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.refusalMeta = data;
    },
    patientProblemsFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.patienProblems = data;
    },
    patientFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.selectedPatient = data;
    },
    selectedNoteSettingsFetch: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.selectedNoteSettings = data;
    },
    practicesFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.practices = data;
    },
    patientsSearched: (state) => {
      state.listLoading = false;
      state.patientsList = data;
    },
    vitalsMetaFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      data.length_unit = [
        { option_id: "in", title: "in" },
        { option_id: "cm", title: "cm" },
      ];
      data.pain_scale = Array.from({ length: 11 }, (v, k) => {
        return { title: k, option_id: k };
      });
      state.vitalsSettings = data;
    },
    referralsMetaFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.referralsSettings = data;
    },
    ccmMetaFetched: (state, action) => {
      const { data } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.ccmSettings = data;
    },
  },
});
